import { cn } from "../../../utils/global.utils";

type Props = {
  classNames?: {
    root?: string;
    header?: string;
    body?: string;
  };
  title: string;
  list: string[];
};

export default function CourseItemList({ classNames, title, list }: Props) {
  return (
    <article
      className={cn(
        "rounded-lg border border-theme-zinc-200",
        classNames?.root
      )}
    >
      <header
        className={cn(
          "px-4 py-2.5 rounded-t-lg text-theme-zinc-700 text-lg lg:text-xl font-medium border-b border-theme-zinc-200",
          classNames?.header
        )}
      >
        {title}
      </header>
      <ul className="p-4 list-inside list-disc space-y-1">
        {list.map((el, idx) => (
          <li
            className="text-theme-slate-500 text-sm lg:text-base"
            key={el + idx}
          >
            {el}
          </li>
        ))}
      </ul>
    </article>
  );
}
